import { ROUTE_ENUM, SVG_ENUM } from "../../../../enums";
import React from "react";
import { SVG } from "../../../../shared";
import "./DashboardMenu.scss";
import { useGetMe } from "../../../../hooks/auth/GetMeHook";
import { useLocation, useNavigate } from "react-router";

const DashboardMenu: React.FC = () => {
  const { data: authorizedUser } = useGetMe();
  const location = useLocation();
  const navigate = useNavigate();
  // Hidden items are not shown in the menu, their pages are available only by a direct link
  const menuItems = [
    { label: "Aktualizacja cen", icon: SVG_ENUM.TAG, link: ROUTE_ENUM.PRICES },
    {
      label: "Zamówienia",
      icon: SVG_ENUM.SHOPPING_CART,
      link: ROUTE_ENUM.ORDERS,
      hidden: true,
    },
    {
      label: "Raporty",
      icon: SVG_ENUM.SQUARE_CHECK,
      link: ROUTE_ENUM.REPORTS,
      hidden: true,
    },
    {
      label: "Zadania konektora",
      icon: SVG_ENUM.REFRESH,
      link: ROUTE_ENUM.TASKS,
    },
    {
      label: "Zarządzanie marżami",
      icon: SVG_ENUM.TRENDING_UP,
      link: ROUTE_ENUM.MARGINS,
    },
    {
      label: "Użytkownicy",
      icon: SVG_ENUM.USERS,
      role: "admin",
      link: ROUTE_ENUM.USERS,
    },
  ];
  return (
    <header className="dashboard-menu">
      <div className="dashboard-menu__logo">
        <SVG type={SVG_ENUM.LOGO} />
      </div>
      <div className="dashboard-menu__content">
        {menuItems.map((item) => {
          if (item.hidden) return null;
          if (item.role && authorizedUser?.role !== item.role) return null;
          return (
            <div
              key={item.label}
              onClick={() => {
                if (location.pathname !== item.link) {
                  navigate(item.link);
                }
              }}
              className={`dashboard-menu__item ${
                location.pathname === item.link ? "active" : ""
              }`}
            >
              <SVG type={item.icon} className="dashboard-menu__item-icon" />
              <span>{item.label}</span>
            </div>
          );
        })}
      </div>
      <div />
    </header>
  );
};

export default DashboardMenu;
